module.exports = __webpack_public_path__ + "static/media/bg-produce_dt.0c6e159a.jpg";